import React, { useContext } from 'react';
import { Activity, DirectLine } from 'botframework-directlinejs';

import { type BotServiceConfig, type ILogger } from '../../types';

export interface IAdsCopilotContextValue {
  activities: Activity[];
  botServiceConfig?: BotServiceConfig;
  logger?: ILogger;
  onBotServiceConfigChange?: (botServiceConfig: BotServiceConfig | undefined) => void;
  onDirectLineCreated: (directLine: DirectLine, username: string, logger?: ILogger) => void;
  pilotMap?: Record<string, boolean>;
  onPilotMapChange?: (pilotMap: Record<string, boolean>) => void;
  onIsSendDisabledChange?: (disabled: boolean) => void;
  isSendDisabled?: boolean;
}

export const AdsCopilotContext = React.createContext<IAdsCopilotContextValue | undefined>(undefined);

export const useAdsCopilotContext = () => useContext(AdsCopilotContext);
